import { render } from "./AdminChangelogModal.vue?vue&type=template&id=5f7644f6"
import script from "./AdminChangelogModal.vue?vue&type=script&lang=js"
export * from "./AdminChangelogModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__